import { createFileRoute } from "@tanstack/react-router";
import { Hero } from "@/components/landing/Hero";
import { HomeExperience } from "@/components/landing/HomeExperience";
import { loadLatestPosts } from "@/lib/latest-posts";
import { homeSeo } from "@/lib/page-seo";
import { resolveSiteContext } from "@/lib/site";

export const Route = createFileRoute("/")({
  loader: async ({ location }) => ({
    href: location.href,
    latestPosts: await loadLatestPosts(resolveSiteContext(location.href)),
  }),
  head: ({ loaderData }) => homeSeo(loaderData?.href ?? "/"),
  component: Index,
});

function Index() {
  const { latestPosts } = Route.useLoaderData();
  return <HomeExperience hero={<Hero />} latestPosts={latestPosts} />;
}
